import React from "react";
import _ from "lodash";
import { Link, useParams } from "react-router-dom";
import { Container, Navbar, Nav } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { motion } from "framer-motion";

import { ReactComponent as HouseIconSVG } from "../../src/images/svg/house.svg";

import siteData from "../content/site_data.json";

export default function Navigation({category_id, project_id}) {

    const category = _.find(siteData.categories, { id: category_id });
    const projects = _.map(category.projects, (projectId) => {
        return _.find(siteData.projects, { id: projectId });
    });

    const renderNavItems = () => {

        const navItems = siteData.navigation;

        return navItems.map((navItem, index) => {

            const isActiveCategory = category_id === navItem.id;

            if (navItem.visible) {

                return (

                    <Nav.Item
                        key={`nav-item-${index}`}
                    >

                        <If condition={isActiveCategory}>
                            <div className={"d-flex justify-content-center w-100"}>
                                <div className="active-item-indicator">
                                </div>
                            </div>
                        </If>

                        <div>
                            <Link
                                className={`nav-link text-nowrap nav-link ${ isActiveCategory ? "active" : ""}`}
                                to={navItem.href}
                                data-rr-ui-event-key={navItem.id}
                            >
                                {navItem.label}
                            </Link>
                        </div>

                    </Nav.Item>
                );
            }

        });
    };

    const getActiveNavBarKey = () => {

        // console.log(`getActiveNavBarKey: ${category_id}`);

        return `${category_id}`;
    };

    const renderProjects = () => {

        return projects.map((p, index) => {

            // TODO -- tmp only
            let imageUrlPrefix = "https://s3.us-east-1.amazonaws.com/s3.museum.amesconstruction.com/d-project-showcase/IMAGES/RESIZED/";

            const isActiveProject = project_id === p.id;

            return (
                <SwiperSlide
                    className={`project-nav-item ${ isActiveProject ? "active" : ""}`}
                    key={`project-nav-item-${index}`}
                >

                    <div className="s-container h-100">

                        <Link
                            to={`/categories/${category_id}/projects/${p.id}`}
                        >

                            <div className="row no-gutters h-100">
                                <div className="col-3 bg-light">

                                    <div
                                        className={"project-thumb h-100"}
                                        style={{
                                            backgroundImage: `url(${ imageUrlPrefix }${ p.thumbUrl })`
                                        }}
                                    >

                                    </div>

                                </div>
                                <div className="col ml-2">

                                    <h6 className={"project-name m-0 text-dark"}>
                                        {p.name}
                                    </h6>

                                    <small className={"text-black-50"}>
                                        {p.location}
                                    </small>

                                </div>
                            </div>

                        </Link>

                    </div>

                </SwiperSlide>
            );
        });
    };

    return (

        <motion.div className={"bg-white"}>

            <div className="category-nav-wrapper">

                <Navbar
                    className={"navbar-theme-red"}
                >

                    <Link
                        className={"navbar-home-icon"}
                        to={"/intro"}
                    >
                        <HouseIconSVG
                            className={"home-icon"}
                        />
                    </Link>

                    <Nav
                        className={"w-100"}
                        activeKey={getActiveNavBarKey()}
                        defaultActiveKey={"/category/all-markets"}
                        justify
                    >

                        {renderNavItems()}

                    </Nav>

                </Navbar>

            </div>

            <div className="project-nav-wrapper">

                <Choose>
                    <When condition={category_id === "all-markets"}>

                        <div
                            className="all-markets-text text-center w-100"
                        >
                            Quality Built Into Every Project
                        </div>

                    </When>
                    <Otherwise>

                        <Swiper
                            className="mySwiper h-100"
                            spaceBetween={0}
                            slidesPerView={"auto"}
                        >

                            {renderProjects()}

                        </Swiper>

                    </Otherwise>
                </Choose>

            </div>

        </motion.div>
    );
}
